import React, { createContext, useState } from 'react';
import VimeoWrapper from '../services/Vimeo';
import Sanity from '../services/Sanity';
export var VideoContext = createContext({
    allVideos: [],
    setSelectedVideo: function (video) { return null; },
    loading: false,
});
var VideoProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), allVideos = _b[0], setAllVideos = _b[1];
    var _c = useState(), selectedVideo = _c[0], setSelectedVideo = _c[1];
    var _d = useState(), pagingState = _d[0], setPagingState = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    Sanity.paginator.setCallbackFn(setPagingState, setAllVideos);
    VimeoWrapper.setLoadingCallback(setLoading);
    return (React.createElement(VideoContext.Provider, { value: {
            allVideos: allVideos,
            selectedVideo: selectedVideo,
            setSelectedVideo: setSelectedVideo,
            pagingState: pagingState,
            loading: loading,
        } }, children));
};
export default VideoProvider;
